"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.58.21v1h2.52L9.73 5.58C9.25 5.22 8.66 5 8.02 5a2.87 2.87 0 0 0-2.84 2.5h-5v1h5.03a2.884 2.884 0 0 0 2.81 2.27 2.88 2.88 0 0 0 2.88-2.88c0-.59-.18-1.13-.48-1.58l4.39-4.39v2.52h1V.21h-4.23ZM8.02 9.76c-1.04 0-1.88-.84-1.88-1.88S6.98 6 8.02 6s1.88.84 1.88 1.88-.84 1.88-1.88 1.88Zm6.79 1.8h1v4.23h-4.23v-1h2.52l-3.49-3.49.71-.71 3.49 3.49v-2.52Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.543.135V1.26h4.417L14.7 8.52a4.255 4.255 0 0 0-2.677-.952 4.263 4.263 0 0 0-4.238 3.87H.195v1.124h7.643a4.26 4.26 0 0 0 4.185 3.518 4.254 4.254 0 0 0 4.252-4.252c0-.923-.3-1.778-.802-2.483l7.282-7.282V6.48h1.125V.135h-6.337Zm-5.52 14.82a3.13 3.13 0 0 1-3.128-3.127A3.13 3.13 0 0 1 12.023 8.7a3.13 3.13 0 0 1 3.127 3.128 3.13 3.13 0 0 1-3.127 3.127Zm10.732 2.565h1.125v6.338h-6.337v-1.125h4.417l-5.768-5.768.796-.795 5.767 5.767V17.52Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.39.18v1.5h5.89l-9.68 9.68a5.673 5.673 0 0 0-3.57-1.27c-2.95 0-5.39 2.27-5.65 5.16H.26v1.5h10.19c.47 2.66 2.79 4.69 5.58 4.69 3.13 0 5.67-2.54 5.67-5.67 0-1.23-.4-2.37-1.07-3.31l9.71-9.71v5.89h1.5V.18h-8.45Zm-7.36 19.76c-2.3 0-4.17-1.87-4.17-4.17s1.87-4.17 4.17-4.17 4.17 1.87 4.17 4.17-1.87 4.17-4.17 4.17Zm14.31 3.42h1.5v8.45h-8.45v-1.5h5.89l-7.69-7.69 1.06-1.06 7.69 7.69v-5.89Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.078.465V2.34h9.292L29.408 17.302a8.272 8.272 0 0 0-5.37-1.98c-4.396 0-7.988 3.42-8.296 7.74H.383v1.875h15.443c.623 3.976 4.065 7.035 8.213 7.035 4.59 0 8.324-3.735 8.324-8.325a8.284 8.284 0 0 0-1.665-4.98L45.706 3.66v9.293h1.875V.465H35.077Zm-11.04 29.633a6.46 6.46 0 0 1-6.45-6.45 6.46 6.46 0 0 1 6.45-6.45 6.46 6.46 0 0 1 6.45 6.45 6.46 6.46 0 0 1-6.45 6.45Zm21.66 4.942h1.874v12.495H35.078V45.66h9.293L32.52 33.81l1.327-1.328 11.85 11.85V35.04Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.77.62v2.5h12.39L39.21 23.07a11.03 11.03 0 0 0-7.16-2.64c-5.86 0-10.65 4.56-11.06 10.32H.51v2.5H21.1c.83 5.3 5.42 9.38 10.95 9.38 6.12 0 11.1-4.98 11.1-11.1 0-2.49-.83-4.78-2.22-6.64L60.94 4.88v12.39h2.5V.62H46.77ZM32.05 40.13c-4.74 0-8.6-3.86-8.6-8.6s3.86-8.6 8.6-8.6 8.6 3.86 8.6 8.6-3.86 8.6-8.6 8.6Zm28.88 6.59h2.5v16.66H46.77v-2.5h12.39l-15.8-15.8 1.77-1.77 15.8 15.8V46.72Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconWorkflowTask = function IconWorkflowTask(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Workflow Task' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "WorkflowTask"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconWorkflowTask.sizes = [16, 24, 32, 48, 64];
IconWorkflowTask.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconWorkflowTask;
exports.default = _default;